/* zas-recommend — dynamic product recommendations from Shopify's own engine.

   Source: /recommendations/products.json?product_id=…&intent=related|complementary
     related        — always returns something: Shopify ranks by purchase history,
                      product descriptions and shared collections.
     complementary  — returns products ONLY where you have set "complementary
                      products" for that item in the Search & Discovery app.
                      Empty otherwise, so every caller must fall back.

   Three jobs:
     1. PDP "You May Also Like"   — related, replacing the static collection rail.
     2. PDP "Complete The Look"   — complementary, filling in wherever the manual
                                    metafield was never set.
     3. Cart drawer               — related to what is in the cart, and when the
                                    customer is short of a free-shipping threshold,
                                    biased toward items in THAT shipping class
                                    priced at or above the gap. That is the point
                                    where shipping and recommendation meet.

   Products tagged clubshop are never shown outside their club page, same as the
   Liquid guard in every rail. The recommendations JSON includes tags, so this
   can be enforced here; /cart.js cannot, which is why cart lines are never used
   as recommendation *sources* without a product_id. */
(function () {
  if (window.__zasRecInit) return;
  window.__zasRecInit = true;
  window.ZAS = window.ZAS || {};

  var cache = {};

  function money(cents) {
    if (window.Zealots && typeof window.Zealots.formatMoney === 'function') {
      return window.Zealots.formatMoney(cents);
    }
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function clean(list, excludeIds) {
    var ex = excludeIds || [];
    return (list || []).filter(function (p) {
      if (!p || !p.available) return false;
      if (ex.indexOf(p.id) !== -1) return false;
      var tags = p.tags || [];
      if (typeof tags === 'string') tags = tags.split(',');
      return !tags.some(function (t) { return String(t).trim().toLowerCase() === 'clubshop'; });
    });
  }

  function fetchRecs(productId, intent, limit) {
    var key = productId + '|' + intent + '|' + limit;
    if (cache[key]) return cache[key];
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
              '&intent=' + encodeURIComponent(intent || 'related') +
              '&limit=' + encodeURIComponent(limit || 8);
    cache[key] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; });
    return cache[key];
  }

  /* Same markup as the Liquid rails, so the existing .pfp-pcard CSS applies. */
  function pdpCard(p) {
    var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var price;
    if (p.compare_at_price && p.compare_at_price > p.price) {
      var off = Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price);
      price = '<div class="pfp-pcard__price pfp-pcard__price--sale">' + money(p.price) + '</div>' +
              '<div class="pfp-pcard__wasrow"><s>' + money(p.compare_at_price) + '</s><span class="pfp-pcard__off">-' + off + '%</span></div>';
    } else {
      price = '<div class="pfp-pcard__price">' + money(p.price) + '</div>';
    }
    return '<a class="pfp-pcard" href="' + esc(p.url) + '">' +
      '<span class="pfp-pcard__heart" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg></span>' +
      img +
      '<div class="pfp-pcard__meta">' + price +
      '<div class="pfp-pcard__name">' + esc(p.title) + '</div>' +
      (p.type ? '<div class="pfp-pcard__type">' + esc(p.type) + '</div>' : '') +
      '</div></a>';
  }

  /* ── 1 & 2: product page rails ─────────────────────────────────────── */
  function initPdp() {
    var host = document.querySelector('[data-rec-product]');
    if (!host) return;
    var pid = parseInt(host.getAttribute('data-rec-product'), 10);
    if (!pid) return;

    var related = document.querySelector('[data-rec-rail="related"]');
    if (related) {
      fetchRecs(pid, 'related', 10).then(function (list) {
        var items = clean(list, [pid]).slice(0, 8);
        if (items.length < 2) return;             /* keep the server-rendered rail */
        related.innerHTML = items.map(pdpCard).join('');
        related.setAttribute('data-rec-filled', 'related');
      });
    }

    var ctl = document.querySelector('[data-rec-rail="complementary"]');
    if (ctl && !ctl.children.length) {
      fetchRecs(pid, 'complementary', 6).then(function (list) {
        var items = clean(list, [pid]).slice(0, 6);
        if (!items.length) return;                /* nothing configured in Search & Discovery */
        ctl.innerHTML = items.map(pdpCard).join('');
        ctl.setAttribute('data-rec-filled', 'complementary');
        var wrap = ctl.closest('[data-rec-ctl-wrap]');
        if (wrap) wrap.hidden = false;
      });
    }
  }

  /* ── 3: cart drawer ────────────────────────────────────────────────── */

  /* Which class is short, and by how much. Uses the same rules as zas-ship.js. */
  function shippingGap(cart) {
    var cfg = window.ZAS.ship;
    if (!cfg || !cart || !cart.items || !cart.items.length) return null;
    var classify = window.ZAS.shipClassify;
    if (!cfg.classesOn || typeof classify !== 'function') {
      var rem = cfg ? (cfg.general - cart.total_price) : 0;
      return rem > 0 ? { cls: 'General', remaining: rem } : null;
    }
    var subs = { General: 0, Bulky: 0, Oversized: 0 };
    cart.items.forEach(function (it) {
      if (it.requires_shipping === false) return;
      subs[classify(it)] += it.final_line_price || it.line_price || 0;
    });
    var thr = { General: cfg.general, Bulky: cfg.bulky, Oversized: cfg.oversized };
    var best = null;
    ['General', 'Bulky', 'Oversized'].forEach(function (c) {
      if (subs[c] <= 0) return;
      var r = thr[c] - subs[c];
      if (r > 0 && (!best || r < best.remaining)) best = { cls: c, remaining: r };
    });
    return best;
  }

  function classOf(p) {
    var classify = window.ZAS.shipClassify;
    if (typeof classify !== 'function') return 'General';
    return classify({ product_type: p.type || p.product_type, product_title: p.title });
  }

  /* Returns a Promise of { title, products[] } or null. */
  function cartRecs(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(null);
    var cartIds = cart.items.map(function (i) { return i.product_id; });
    var gap = shippingGap(cart);

    /* Seed from the item in the short class if there is one, else the newest line. */
    var seed = cart.items[0];
    if (gap && typeof window.ZAS.shipClassify === 'function') {
      var m = cart.items.filter(function (it) { return window.ZAS.shipClassify(it) === gap.cls; });
      if (m.length) seed = m[0];
    }

    return fetchRecs(seed.product_id, 'related', 10).then(function (list) {
      var items = clean(list, cartIds);
      if (!items.length) return null;

      if (gap) {
        var same = items.filter(function (p) { return classOf(p) === gap.cls; });
        /* Cheapest item that closes the gap first: the customer is looking
           to spend the gap, not three times it. */
        var covers = same.filter(function (p) { return p.price >= gap.remaining; })
                         .sort(function (a, b) { return a.price - b.price; });
        var pick = covers.concat(same.filter(function (p) { return covers.indexOf(p) === -1; }));
        if (pick.length) {
          var label = gap.cls === 'General' ? '' : (gap.cls === 'Bulky' ? ' of pads & helmets' : ' of bats & bags');
          return {
            title: 'Add ' + money(gap.remaining) + ' more' + label + ' and shipping’s free',
            products: pick.slice(0, 3),
            gap: gap
          };
        }
      }
      return { title: 'Pairs well with your cart', products: items.slice(0, 3), gap: null };
    });
  }

  window.ZAS.recommend = {
    fetch: fetchRecs,
    clean: clean,
    pdpCard: pdpCard,
    cartRecs: cartRecs,
    shippingGap: shippingGap
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp);
  else initPdp();
})();
